export const DEFAULT_COUNTS = {
    sha: {
        1000: 2,
        1850: 4,
        1950: 4,
    },
    instrumentalniy: {
        shi: 3,
        shir: 3,
        shio: 2,
        ship: 4,
    },
};

export const DRAG_STEPS = {
    sha: 0.05,
    instrumentalniy: 0.04,
};

export const MIN_MAX_SHKAFY = {
    sha: {
        1000: {
            min: 10.059,
            max: 10.761,
        },
        1850: {
            min: 10.059,
            max: 11.611,
        },
        1950: {
            min: 10.059,
            max: 11.799,
        },
    },
    instrumentalniy: {
        2000: {
            min: 10.059,
            max: 11.859,
        },
    },
};

export const Y_MAP_SHELVES = {
    sha: {
        1000: {
            1: 10.359,
            2: 10.761,
            3: 10.159,
            4: 10.559,
        },
        1850: {
            1: 10.159,
            2: 10.559,
            3: 10.959,
            4: 11.359,
            5: 10.359,
            6: 10.759,
            7: 11.159,
            8: 11.509,
            9: 11.611,
        },
        1950: {
            1: 10.409,
            2: 10.809,
            3: 11.209,
            4: 11.609,
            5: 10.209,
            6: 10.609,
            7: 11.009,
            8: 11.409,
            9: 11.799,
        },
    },
    instrumentalniy: {
        shi: {
            1: 10.659,
            2: 11.219,
            3: 11.579,
        },
        shir: {
            1: 10.379,
            2: 11.219,
            3: 11.659,
        },
        shio: {
            1: 11.019,
            2: 11.539,
        },
        ship: {
            1: 10.339,
            2: 10.699,
            3: 11.219,
            4: 11.579,
        },
    },
};

export const Y_MAP_YASHCHIKS = {
    shi: {
        small: {
            1: 10.539,
            2: 10.419,
            3: 10.979,
            4: 11.099,
        },
    },
    shir: {
        small: {
            1: 10.859,
            2: 10.739,
            3: 10.979,
            4: 11.099,
        },
    },
    shio: {
        small: {
            1: 10.539,
            2: 10.779,
            3: 10.899,
            4: 10.659,
        },
        big: {
            1: 10.299,
            2: 10.059,
        },
    },
};

export const DEFAULT_COUNTS_YASHCHIKS = {
    shi: {
        big: 0,
        small: 4,
    },
    shir: {
        big: 0,
        small: 4,
    },
    shio: {
        big: 2,
        small: 4,
    },
    ship: {
        big: 0,
        small: 0,
    },
};
